import SimpleLightbox from 'simplelightbox';

export default function translateDate() {
}

$('.main-carousel').flickity({
    // options
    cellAlign: 'left',
    contain: true,
    autoPlay: true,
    cellSelector: '.carousel-cell',
});

var lightbox = new SimpleLightbox('.gallery a', { /* options */ });
lightbox.on('show.simplelightbox', function () {
    // do something…
});


// WEBPACK FOOTER //
// ./scripts/routes/used-cars.js